import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Footer from "./footer/Footer";
import ApiMicroservices from "./pages/services/ApiMicroservices";
import MobileDevelopment from "./pages/services/MobileDevelopment";
import RPA from "./pages/services/RPA";
import ArtificialIntelligence from "./pages/services/ArtificialIntelligence";
import WebDevelopment from "./pages/services/WebDevelopment";
import Industries from "./pages/Industries";
import Careers from "./pages/Careers";
import ApplyJob from "./pages/ApplyJob";


function Layout() {
  const location = useLocation();
  const hideNavbar = location.pathname === "/verify";

  return (
    <>
      {<Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/verify" element={<Contact />} />
        <Route path="/services/api-microservices" element={<ApiMicroservices />} />
        <Route path="/services/mobile-development" element={<MobileDevelopment />} />
        <Route path="/services/rpa" element={<RPA />} />
        <Route path="/services/artificial-intelligence" element={<ArtificialIntelligence />} />
        <Route path="/services/web-development" element={<WebDevelopment />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/apply" element={<ApplyJob />} />
        
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}
